/**
 * Loop items and apply custom nav function.
 *
 * @param menuItems
 * @param onNavigate
 * @param onNavigateOptions options object
 */
export const applyOnNavigate = (menuItems, onNavigate, onNavigateOptions) => {
    return menuItems.map((item) => {
        let link = {
            ...item,
        };
        if (item.href && !item.onClick) {
            // apply custom navigation handler to the link.
            link = {
                ...link,
                onClick: (event) => {
                    if (item.href) {
                        if ("ontouchstart" in window && link.links) {
                            event.preventDefault();
                            return;
                        }
                        if (onNavigate)
                            onNavigate(event, item.href, onNavigateOptions, item.label);
                    }
                },
            };
        }
        if (item.links && item.links.length) {
            link = {
                ...link,
                links: applyOnNavigate(item.links, onNavigate, onNavigateOptions),
            };
        }
        return link;
    });
};
